<template>
    <div class="vld-parent">
        <loading :active.sync="show" 
        :can-cancel="false" 
        :height="120"
        :width="120"
        color="#2E62FF"
        loader="bars"
        background-color="#eee"
        :is-full-page="true"></loading>
    </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'loader',
  props: ['show'],
  components: {Loading},
  data: function () {
    return {
      titulo: ''
    }
  },
}
</script>